import SPHMediaLogoFooter from "@assets/SPHMediaLogo.svg";
import TMMobileLogoFooter from "@assets/tm_logo_mobile.png";
import { FooterAdvertise } from "@footer/FooterAdvertise";
import { FooterCopyright } from "@footer/FooterCopyright";
import { FooterLinks } from "@footer/FooterLinks";
import { FooterNewsletterSignup } from "@footer/FooterNewsletterSignup";
import FooterNewsPublication from "@footer/FooterNewsPublication";
import type { ReactElement } from "react";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

export type FooterProps = {
  testId?: string;
  className?: string;
  showNewsletterSignup?: boolean;
  subPublication?: string;
};

export function Footer({
  testId = "footer",
  className,
  showNewsletterSignup = true,
  subPublication,
}: FooterProps): ReactElement {
  return (
    <>
      <footer
        className={twMerge(
          "bg-red-400 mt-500 max-w-full px-2 lg:px-0",
          className,
        )}
      >
        {showNewsletterSignup && <FooterNewsletterSignup />}
        <div className="flex">
          <div
            data-testid={`${testId}-footerContainer`}
            className="flex flex-wrap gap-y-5 lg:flex-row gap-x-5 xl:max-w-xl lg:max-w-lg md:max-w-full sm:max-w-full w-full mx-auto py-5 xl:pb-500 xs:px-sm xl:px-xxs font-primary max-xs:px-xxs max-xs:py-4"
          >
            <div className="flex flex-col gap-y-5 lg:gap-y-4 lg:gap-x-5">
              <div className="flex">
                <Link reloadDocument to="/" rel="home" title="Tamil Murasu">
                  <img
                    height="30px"
                    width="144px"
                    className="block mt-[7px]"
                    alt="Home"
                    src={TMMobileLogoFooter}
                  />
                </Link>
                <span className="border-l border-solid border-gray-400 mx-xs"></span>
                <Link
                  to="https://www.sph.com.sg/"
                  rel="home noopener noreferrer"
                  title="Home"
                  target="_blank"
                >
                  <img
                    height="47px"
                    width="139px"
                    alt="Home"
                    src={SPHMediaLogoFooter}
                  />
                </Link>
              </div>
              <FooterNewsPublication />
              <div>
                <FooterCopyright
                  testId={testId}
                  subPublication={subPublication}
                />
                <FooterLinks testId={testId} />
              </div>
            </div>
            <FooterAdvertise testId={testId} />
          </div>
        </div>
      </footer>
    </>
  );
}
